import { defineCustomElements } from '@ionic/pwa-elements/loader';

export default function () {
  defineCustomElements(window);
}
